import * as globals from '@wandb/common/css/globals.styles';
import React, {FC, memo} from 'react';
import styled from 'styled-components';

type KeyboardShortcutProps = {
  keys: string[];
  className?: string;
};

const KeyboardShortcutComp: FC<KeyboardShortcutProps> = ({keys, className}) => {
  return (
    <Keys className={className}>
      {keys.map((k, i) => (
        <Key key={i}>{k}</Key>
      ))}
    </Keys>
  );
};

const KeyboardShortcut = memo(KeyboardShortcutComp);

export default KeyboardShortcut;

const Keys = styled.div`
  display: inline-flex;
`;

const Key = styled.div`
  display: inline-block;
  padding: 2px 6px;
  color: ${globals.GRAY_350};
  background-color: ${globals.hexToRGB(globals.MOONBEAM, 0.1)};
  border-radius: 3px;

  &:not(:first-child) {
    margin-left: 1px;
  }
`;
